export function setTableData(state, payload) {
    state.items.data = payload.data;
    state.items.pagination = payload.pagination;
    state.items.filter = payload.filter;
}

export function setLastUpdated(state) {
  state.lastUpdated = new Date().getTime()
}

